import Deferred from 'utils/deferred';

var deferred = new Deferred();

export function registerContext(ctx) {
  deferred.resolve(ctx);
}

export function resolveContext() {
  return deferred.promise;
}
